import { Button, HStack, Icon, Text } from '@chakra-ui/react'
import { LuInbox, LuArchive, LuFileStack } from 'react-icons/lu'
import type { DashboardFilter } from '../domain/types'

type Props = {
  value: DashboardFilter
  onChange: (value: DashboardFilter) => void
}

const OPTIONS = [
  {
    label: 'Offen',
    value: 'OPEN',
    icon: LuInbox,
  },
  {
    label: 'Alle',
    value: 'ALL',
    icon: LuFileStack,
  },
  {
    label: 'Archiv',
    value: 'ARCHIVE',
    icon: LuArchive,
  },
]

export function ServiceBillingTabs({ value, onChange }: Props) {
  return (
    <HStack gap={1} borderWidth="1px" borderColor="border" borderRadius="lg" p="1">
      {OPTIONS.map(option => {
        const isActive = value === option.value

        return (
          <Button
            key={option.value}
            size="sm"
            variant={isActive ? 'subtle' : 'ghost'}
            colorPalette={isActive ? 'blue' : 'gray'}
            onClick={() => onChange(option.value as DashboardFilter)}
          >
            <HStack gap={2}>
              <Icon as={option.icon} />
              <Text>{option.label}</Text>
            </HStack>
          </Button>
        )
      })}
    </HStack>
  )
}
